import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=319dcb8a"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=319dcb8a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('319dcb8a')) {
      api.createRecord('319dcb8a', component.options)
    } else {
      api.reload('319dcb8a', component.options)
    }
    module.hot.accept("./RegisterForm.vue?vue&type=template&id=319dcb8a", function () {
      api.rerender('319dcb8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/register/assets/frontend/vue/RegisterForm.vue"
export default component.exports